import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '../../../../../../utils';
import { STATUS_LABELS } from '../../constants';
import ReactTableComponent from 'components/ReactTableComponent';

export function AccountsTable(props) {
  const { accountsContent, isLoading, onSortedChange } = props;

  const columns = useMemo(() => {
    return [
      {
        Header: 'Брокер',
        accessor: 'brokerName',
        Cell: ({ value, original: { brokerInn } }) => `${value} (ИНН ${brokerInn})`,
        minWidth: 150,
      },
      {
        Header: 'Номер и дата договора',
        accessor: 'contractDateBegin',
        Cell: ({ value, original: { contractNumber } }) =>
          `№ ${contractNumber}${value ? ` от ${formatDate(value)}` : ''}`,
        minWidth: 200,
      },
      {
        Header: 'Дата открытия',
        accessor: 'iisOpenDate',
        Cell: ({ value }) => `${formatDate(value) || '-'}`,
        minWidth: 150,
      },
      {
        Header: 'Состояние счета',
        accessor: 'iisState',
        Cell: ({ value }) => STATUS_LABELS[value] || value,
        minWidth: 150,
      },
      {
        Header: 'Дата расторжения',
        accessor: 'iisEndDate',
        Cell: ({ value }) => `${formatDate(value) || '-'}`,
        minWidth: 150,
      },
    ];
  }, []);

  return (
    <ReactTableComponent
      theme={'blue'}
      sortable
      columns={columns}
      tableData={accountsContent}
      isLoading={isLoading}
      onSortedChange={onSortedChange}
    />
  );
}

AccountsTable.propTypes = {
  accountsContent: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onSortedChange: PropTypes.func.isRequired,
};
